<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import ZinputExpander from './zinput-expander.svelte'
    import { zinputPalettes } from './zinput-palette-colors'

    export let value: string = null
    export let palette: string = 'pastel'
    export let disabled = false
    export let labeled = false
    export let label = ''
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    let expander: ZinputExpander

    $: colors = zinputPalettes[palette] || []

    function selectColor(color: string) {
        if (disabled) return
        value = color
        dispatch('change')
        expander.close()
    }

    function onSwatchKeydown(ev, color: string) {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault()
            selectColor(color)
        }
    }
</script>

<ZinputExpander titulo={label} {disabled} {labeled} bind:htmlInput bind:this={expander}>
    <svelte:fragment slot="trigger">
        {#if value}
            <span class="palette_swatch-full" style="background-color: {value}"></span>
        {/if}
    </svelte:fragment>
    <svelte:fragment slot="panel">
        <div class="palette_grid">
            {#each colors as color (color)}
                <div
                    class="palette_swatch-btn"
                    class:selected={value === color}
                    style="background-color: {color}"
                    role="radio"
                    aria-checked={value === color}
                    tabindex="0"
                    title={color}
                    on:click={() => selectColor(color)}
                    on:keydown={(ev) => onSwatchKeydown(ev, color)}
                ></div>
            {/each}
        </div>
    </svelte:fragment>
</ZinputExpander>

<style>
    .palette_swatch-full {
        flex-grow: 1;
        align-self: stretch;
        border-radius: 4px;
        min-height: 20px;
        margin: 2px 0px 2px 8px;
    }

    .palette_grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 4px 12px;
    }

    .palette_swatch-btn {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        border: 2px solid transparent;
        cursor: pointer;
    }

    .palette_swatch-btn:hover {
        border-color: #ffffff60;
    }

    .palette_swatch-btn.selected {
        border-color: #fff;
        box-shadow: 0 0 0 2px #00000080;
    }

    :global(.theme_light) .palette_swatch-btn.selected {
        box-shadow: 0 0 0 2px #ffffff80;
    }
</style>
